<template>
  <div class="LocaleSelectorLogin">
    <ul>
      <li
        :class="currentLocale() === 'da' ? 'current' : ''"
        @click="setLocale('da')"
      >
        <button>DK</button>
      </li>
      <li
        :class="currentLocale() === 'en' ? 'current' : ''"
        @click="setLocale('en')"
      >
        <button>EN</button>
      </li>
      <li
        :class="currentLocale() === 'de' ? 'current' : ''"
        @click="setLocale('de')"
      >
        <button>DE</button>
      </li>
      <li
        :class="currentLocale() === 'fr' ? 'current' : ''"
        @click="setLocale('fr')"
      >
        <button>FR</button>
      </li>
      <li
        :class="currentLocale() === 'pl' ? 'current' : ''"
        @click="setLocale('pl')"
      >
        <button>PL</button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'LocaleSelectorLogin',
}
</script>

<style lang="scss">
@import 'style.scss';
</style>
